import styled from 'styled-components';

export const Nav = styled.nav`
background: #004892;
padding: 5px 1px 5px 1px;
display: flex;
justify-content: space-between;
align-items: center;


a {
  color: rgb(230, 230, 230);
  font-weight: bold;
}

a img {
  width: 5rem;
  cursor: pointer;
  margin-right: 1rem;
}

.icon-color {
  color: rgb(230, 230, 230);
  background-color: #004892;
  border: none;

}
`;

export const Menu = styled.div`


  `;
